import SortNumberDesc from './sort-number-desc';

export * from './sort-number-desc';
export default SortNumberDesc;
